import { Box, styled, Chip } from '@mui/material';

const SelectedRowsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.375),
  padding: theme.spacing(0.375, 0.5),
  marginBottom: theme.spacing(0.375),
  maxHeight: 80,
  overflowY: 'auto',
  overflowX: 'hidden',
  width: '100%',
  minWidth: 0,
}));

const RowChip = styled(Chip)(({ theme }) => ({
  height: 20,
  width: '100%',
  border: `1px solid ${theme.palette.secondary.dark}`,
  backgroundColor: theme.palette.secondary.light,
  '& .MuiChip-label': {
    overflow: 'hidden',
    '& .MuiTypography-root, & a': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '0.75rem',
      lineHeight: 1.2,
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}));

export { SelectedRowsWrapper, RowChip };
